"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentAge = CurrentAge;
exports.FutureGroceriesAndDiningOutCost = FutureGroceriesAndDiningOutCost;
exports.FutureHealthcareAndInsurance = FutureHealthcareAndInsurance;
exports.FutureHousingAndInsurance = FutureHousingAndInsurance;
exports.FuturePersonalAndMiscellaneousCost = FuturePersonalAndMiscellaneousCost;
exports.FutureTransportationAndInsurance = FutureTransportationAndInsurance;
exports.FutureTravelAndEntertainmentCost = FutureTravelAndEntertainmentCost;
exports.GroceriesAndDiningOut = GroceriesAndDiningOut;
exports.HealthcareAndInsurance = HealthcareAndInsurance;
exports.HousingAndInsurance = HousingAndInsurance;
exports.OtherIncome = OtherIncome;
exports.Pension = Pension;
exports.PersonalAndMiscellaneous = PersonalAndMiscellaneous;
exports.RetirementAge = RetirementAge;
exports.SecondaryGroceriesAndDiningOutCost = SecondaryGroceriesAndDiningOutCost;
exports.SecondaryHealthcareAndInsurance = SecondaryHealthcareAndInsurance;
exports.SecondaryHousingAndInsurance = SecondaryHousingAndInsurance;
exports.SecondaryPersonalAndMiscellaneousCost = SecondaryPersonalAndMiscellaneousCost;
exports.SecondaryTransportationAndInsurance = SecondaryTransportationAndInsurance;
exports.SecondaryTravelAndEntertainmentCost = SecondaryTravelAndEntertainmentCost;
exports.SocialSecurityBenefit = SocialSecurityBenefit;
exports.TransportationAndInsurance = TransportationAndInsurance;
exports.TravelAndEntertainment = TravelAndEntertainment;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _House = _interopRequireDefault(require("./svg/House"));
var _Medical = _interopRequireDefault(require("./svg/Medical"));
var _Car = _interopRequireDefault(require("./svg/Car"));
var _Grocery = _interopRequireDefault(require("./svg/Grocery"));
var _Travel = _interopRequireDefault(require("./svg/Travel"));
var _Dog = _interopRequireDefault(require("./svg/Dog"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RetirementAge(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'retirementAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var htmlSize = '3';
  var placeholder = '00';
  var preText = ' and I plan to retire at ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: "endOfSentence"
  });
}
function CurrentAge(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'currentAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var htmlSize = '3';
  var placeholder = '00';
  var preText = 'I am ';
  var postText = ' years old ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function HousingAndInsurance(_ref3) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref3;
  var fieldName = 'housingAndInsuranceCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Housing & Insurance",
    svg: /*#__PURE__*/_react.default.createElement(_House.default, {
      className: "mm-spacing--minor"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function HealthcareAndInsurance(_ref4) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref4;
  var fieldName = 'healthcareAndInsuranceCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Healthcare & Insurance",
    svg: /*#__PURE__*/_react.default.createElement(_Medical.default, {
      className: "mm-spacing--minor"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function TransportationAndInsurance(_ref5) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref5;
  var fieldName = 'transportationAndInsuranceCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Transportation & Insurance",
    svg: /*#__PURE__*/_react.default.createElement(_Car.default, {
      className: "mm-spacing--minor flex-grow-by-1"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function PersonalAndMiscellaneous(_ref6) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref6;
  var fieldName = 'personalAndMiscellaneousCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Personal & Miscellaneous",
    svg: /*#__PURE__*/_react.default.createElement(_Dog.default, {
      className: "mm-spacing--minor flex-grow-by-1"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function TravelAndEntertainment(_ref7) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref7;
  var fieldName = 'travelAndEntertainmentCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Travel & Entertainment",
    svg: /*#__PURE__*/_react.default.createElement(_Travel.default, {
      className: "mm-spacing--minor flex-grow-by-1"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function GroceriesAndDiningOut(_ref8) {
  var {
    errors,
    touched,
    values,
    onClick
  } = _ref8;
  var fieldName = 'groceriesAndDiningOutCost';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  var formControl = /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
  return /*#__PURE__*/_react.default.createElement(FormControlWithIcon, {
    label: "Groceries & Dining Out",
    svg: /*#__PURE__*/_react.default.createElement(_Grocery.default, {
      className: "mm-spacing--minor flex-grow-by-1"
    }),
    formControl: formControl,
    fieldName: fieldName,
    onClick: onClick
  });
}
function FormControlWithIcon(_ref9) {
  var {
    label,
    svg,
    formControl,
    fieldName,
    onClick
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 col-xs-12 mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-content-object--centered"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    className: "flex-grow-by-1",
    htmlFor: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "mm-text-center "
  }, label)), svg, formControl, /*#__PURE__*/_react.default.createElement("span", {
    className: "mouse-pointer"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "link",
    "data-bp-link": "default",
    onClick: onClick
  }, "Itemize Your Expenses"))));
}
function SocialSecurityBenefit(_ref10) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'socialSecurityBenefit';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var htmlSize = '10';
  var placeholder = '0';
  var preText = 'I estimate my Social Security will be ';
  var postText = ' a month. ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function Pension(_ref11) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'pension';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var htmlSize = '10';
  var placeholder = '0';
  var preText = 'My pension will be ';
  var postText = ' a month and other expected monthly income ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function OtherIncome(_ref12) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref12;
  var fieldName = 'otherIncome';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var htmlSize = '10';
  var placeholder = '0';
  var preText = ' will be ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    setFieldValue: setFieldValue,
    preText: preText,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: "endOfSentence"
  });
}
function SecondaryHousingAndInsurance(_ref13) {
  var {
    errors,
    touched,
    values
  } = _ref13;
  var fieldName = 'housingAndInsuranceCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FutureHousingAndInsurance(_ref14) {
  var {
    errors,
    touched,
    values
  } = _ref14;
  var fieldName = 'future_housingAndInsuranceCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SecondaryHealthcareAndInsurance(_ref15) {
  var {
    errors,
    touched,
    values
  } = _ref15;
  var fieldName = 'healthcareAndInsuranceCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FutureHealthcareAndInsurance(_ref16) {
  var {
    errors,
    touched,
    values
  } = _ref16;
  var fieldName = 'future_healthcareAndInsuranceCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SecondaryTransportationAndInsurance(_ref17) {
  var {
    errors,
    touched,
    values
  } = _ref17;
  var fieldName = 'transportationAndInsuranceCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FutureTransportationAndInsurance(_ref18) {
  var {
    errors,
    touched,
    values
  } = _ref18;
  var fieldName = 'future_transportationAndInsuranceCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SecondaryGroceriesAndDiningOutCost(_ref19) {
  var {
    errors,
    touched,
    values
  } = _ref19;
  var fieldName = 'groceriesAndDiningOutCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FutureGroceriesAndDiningOutCost(_ref20) {
  var {
    errors,
    touched,
    values
  } = _ref20;
  var fieldName = 'future_groceriesAndDiningOutCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SecondaryTravelAndEntertainmentCost(_ref21) {
  var {
    errors,
    touched,
    values
  } = _ref21;
  var fieldName = 'travelAndEntertainmentCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FutureTravelAndEntertainmentCost(_ref22) {
  var {
    errors,
    touched,
    values
  } = _ref22;
  var fieldName = 'future_travelAndEntertainmentCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SecondaryPersonalAndMiscellaneousCost(_ref23) {
  var {
    errors,
    touched,
    values
  } = _ref23;
  var fieldName = 'personalAndMiscellaneousCost';
  var label = 'Current Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    disabled: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function FuturePersonalAndMiscellaneousCost(_ref24) {
  var {
    errors,
    touched,
    values
  } = _ref24;
  var fieldName = 'future_personalAndMiscellaneousCost';
  var label = 'Estimated Future Expense';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName,
    label: label,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}